import React, { ReactNode, ReactNodeArray } from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import TouristESimBlockData from '../../../Models/Content/TouristESimBlockData';
import TouristESim from './TouristESim';
import InformationPage from './Pages/InformationPage';
import PackagePage from './Pages/PackagePage';


export default class TouristESimBlock extends EpiComponent<TouristESimBlockData> {

  constructor(props) {

    super(props);
  }

  public render(): ReactNode | ReactNodeArray | null {
    return <div>
      <TouristESim iContent={this.props.data} context={this.getContext()} />
    </div>;
  }
}